// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3RlIX","title":"Header_title__1yHUA","left":"Header_left__31UwI","clinicName":"Header_clinicName__1Ez7H"};